import { Button } from "../../../utils/Button";
import { GameVars } from "../../../GameVars";
import { HiLoManager } from "../../../managers/HiLoManager";
import { GameConstants } from "../../../GameConstants";
import { AudioManager } from "../../../managers/AudioManager";
import { Translation } from "../../../Translation";

export class HiLoButtonsContainer extends Phaser.GameObjects.Container {

    private hiButton: Button;
    private loButton: Button;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.scaleX = GameVars.scaleX;

        const w = 200;
        const h = 240;

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x000000, .35);
        background.fillRoundedRect(-w / 2 + 10, -h / 2 + 510, w, h, 20);
        this.add(background);

        const nextCardLabel = new Phaser.GameObjects.Text(this.scene, 10, 418, Translation.getText("NEXT_CARD_"), { fontFamily: "Oswald-Medium", fontSize: "32px", color: "#FFFFFF", align: "center" });
        nextCardLabel.setOrigin(.5);
        this.add(nextCardLabel);

        this.hiButton = new Button(this.scene, 0, 485, "texture_atlas_1", "btn_red.png", "btn_red.png", true, false, .9);
        this.hiButton.onDown(this.onClickHiButton, this);
        this.add(this.hiButton);

        const hiLabel = new Phaser.GameObjects.Text(this.scene, 0, this.hiButton.y, Translation.getText("HIGHER"), { fontFamily: "Oswald-Medium", fontSize: "32px", color: "#871947", align: "center" });
        hiLabel.setOrigin(.5);
        this.add(hiLabel);

        const hiArrow = new Phaser.GameObjects.Image(this.scene, 85, this.hiButton.y, "texture_atlas_1", "arrow_higher.png");
        this.add(hiArrow);

        this.loButton = new Button(this.scene, 0, 575, "texture_atlas_1", "btn_blue.png", "btn_blue.png", true, false, .9);
        this.loButton.onDown(this.onClickLoButton, this);
        this.loButton.setScale(.9);
        this.add(this.loButton);

        const loLabel = new Phaser.GameObjects.Text(this.scene, 0, this.loButton.y, Translation.getText("LOWER"), { fontFamily: "Oswald-Medium", fontSize: "32px", color: "#064150", align: "center" });
        loLabel.setOrigin(.5);
        this.add(loLabel);

        const loArrow = new Phaser.GameObjects.Image(this.scene, 85, this.loButton.y, "texture_atlas_1", "arrow_lower.png");
        this.add(loArrow);
    }

    public onGameOver(): void {

        this.hiButton.disableInteractive();
        this.hiButton.alpha = .35;

        this.loButton.disableInteractive();
        this.loButton.alpha = .35;
    }

    public onGameCompleted(): void {

        this.hiButton.disableInteractive();
        this.hiButton.alpha = .35;

        this.loButton.disableInteractive();
        this.loButton.alpha = .35;
    }

    public onReplay(): void {

        this.hiButton.setInteractive();
        this.hiButton.alpha = 1;

        this.loButton.setInteractive();
        this.loButton.alpha = 1;
    }

    private onClickHiButton(): void {

        if (GameVars.paused) {
            return;
        }

        AudioManager.playSound("btn_click");

        HiLoManager.onBetPlaced(GameConstants.HIGHER);
    }

    private onClickLoButton(): void {

        if (GameVars.paused) {
            return;
        }

        AudioManager.playSound("btn_click");

        HiLoManager.onBetPlaced(GameConstants.LOWER);
    }
}
